import { useEffect } from "react";

const Contact = () => {
  const SITE_NAME = "AHA Printing Solutions LLC";
  const SITE_URL = "http://localhost/paperchase"; // change later
  const POLICY_URL = "https://ahaprinting.net/";

  // BUSINESS INFO
  const BUSINESS_NAME = "AHA Printing Solutions LLC";
  const BUSINESS_ADDRESS = "1648 Fry Rd, Ste D Greenwood, Indiana 46142-1117";
  const BUSINESS_PHONE = "+1-317-625-1452";
  const BUSINESS_EMAIL = "info@ahaprinting.net";
  const POLICIES_EMAIL_URL = "ahaprinting.net";

  return (
    <section className="contact py-80">
      {/* Page-only styling */}
      <style>{`
        .contact h1,
        .contact h2,
        .contact h3,
        .contact h4,
        .contact h5,
        .contact h6 {
          font-size: 28px;
          margin-top: 20px;
          margin-bottom: 20px;
        }
      `}</style>

      <div className="container container-lg">
        <div className="row gy-5">
          <div className="col-lg-12">
            <div className="contact-box px-24 py-40">
              {/* Start */}

              {/* End */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
